import { checkOperationCases } from '../utils';
export function createRemoveMethod(ref) {
    return function remove(item) {
        if (!item) {
            return ref.remove();
        }
        return checkOperationCases(item, {
            stringCase: function () { return ref.child(item).remove(); },
            firebaseCase: function () { return item.remove(); },
            snapshotCase: function () { return item.ref.remove(); }
        });
    };
}
//# sourceMappingURL=remove.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angularfire2/database/list/remove.js
// module id = 1394
// module chunks = 21